import styled from 'styled-components';
import { propStyling } from '../../../shared/propStyling';
import { textStyles } from '../../../shared/textStyles';
import { tombac } from '../../../shared/tombac';
export const ModalHeader = styled.div.withConfig({
  displayName: "ModalHeader"
})(["all:initial;display:block;margin:", ";", " &:last-child{margin-bottom:", ";}", " ", ""], tombac.space(3, 3, 0), tombac.altText({
  fontWeight: 'bold',
  fontSize: 16
}), tombac.space(3), propStyling, textStyles);
//# sourceMappingURL=ModalHeader.js.map